
<div class="padding-20 ui-g" id="c3_searchDetartment_Modal">

   
   <!-- Bottoni Annulla e Aggiungi -->
 
   <div class="ui-dialog-footer fixed-buttons buttonsContainer">
     <button pButton (click)="onClickAnnullaDepartment()" type="button" class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
     <button pButton type="button" (click)="onClickAggiungiDepartment()" type="button" class="k-generic-btn footer-btn" label="{{'common.add' | translate}}"></button>
     <div class="clear_fix"></div>
   </div>
 
   <br />
   <br />
   <br />

  <app-campaign-3-kontable 
  *ngIf="departmentList && show.table"
  id="departmentList"            
  [columns] = "[         
  { field: 'id', title: 'Id' },
  { field: 'code', title: 'campaign.code' },
  { field: 'reparto', title: 'campaign.department' },
  { field: 'description', title: 'campaign.description' },
  { field: 'variante', title: 'campaign.variant' }
]"
  [paginationType]="paginationType"
  [showInfoButton]="false"            
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="false"
  [source]="departmentList"
  [showSelectButton]="true"
  (onSelected)="onDepartmentSelected($event)"
  #departmentListTable>


</app-campaign-3-kontable>  
 
  
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-department/campaign-3-search-department.component.html